import { Ref, computed } from 'vue-demi';
import {
  SplitTestType,
  VideoDurationType,
  OptimizeGoal,
  SplitTestTargetResult,
  AdgroupFormData,
} from '@tt4b/ttam-enums';
import { useGetKeyMetricListApi, useRequest } from '@tt4b/ttam-hooks';
import { underscoreFormData } from '@tt4b/ttam-utils';
import { i18n } from './../../i18n';
// import { trackEvent } from '@/track/utils';
// import { useSplitTestStoreGetter } from '@/hooks/creation/splittest/use-split-test-store-getter';
// import { useSplitTestStoreSetter } from '@/hooks/creation/splittest/use-split-test-store-setter';

const getMatricMap = () => ({
  [SplitTestTargetResult.COST_PER_CONVERT]: {
    [OptimizeGoal.CONVERT]: i18n.t('module_split_test_key_metric_cost_per_conversion'),
    [OptimizeGoal.INSTALL]: i18n.t('module_split_test_key_metric_cost_app_install'),
    [OptimizeGoal.LEAD]: i18n.t('module_split_test_key_metric_cost_per_lead'),
    [OptimizeGoal.IN_APP_EVENT]: i18n.t('module_split_test_key_metric_cost_per_conversion'),
    [OptimizeGoal.FANS]: i18n.t('module_split_test_key_metric_cost_per_follow'),
    [OptimizeGoal.WEBVIEWS]: i18n.t('module_split_test_key_metric_cost_per_profile_visit'),
  },
  [SplitTestTargetResult.COST_PER_REACH]: i18n.t('module_split_test_key_metric_cpr'),
  [SplitTestTargetResult.COST_PER_CLICK]: i18n.t('module_split_test_key_metric_cpc'),
  [SplitTestTargetResult.COST_PER_VALID_PLAY]: {
    [OptimizeGoal.VIDEO_VIEW]: {
      [VideoDurationType.SIX_SECONDS]: i18n.t('module_split_test_key_metric_6_video_view'),
      [VideoDurationType.TWO_SECONDS]: i18n.t('module_split_test_key_metric_2_video_view'),
    },
  },
  [SplitTestTargetResult.CTR]: i18n.t('module_split_test_key_metric_ctr'),
  [SplitTestTargetResult.CVR]: i18n.t('module_split_test_key_metric_cvr'),
  [SplitTestTargetResult.COST_PER_SHOW]: i18n.t('module_split_test_key_metric_cpm'),
});

const { data: keyMetricList, run: getKeyMetricList } = useRequest(useGetKeyMetricListApi, null, {
  manual: true,
});

export function initKeyMetric(params: {
  optimizeGoal: number;
  // 这个字段可以不传
  cpvVideoDurationType?: VideoDurationType;
}) {
  if (keyMetricList.value?.length > 0) {
    return keyMetricList.value;
  }
  return getKeyMetricList(underscoreFormData(params));
}

export function useKeyMetric(adgroupData: Ref<AdgroupFormData>) {
  const matricMap = getMatricMap();

  const keyMetricOptions = computed(() =>
    keyMetricList.value?.map?.(metric => {
      const { optimizeGoal } = adgroupData.value;
      const cpvVideoDuration = adgroupData.value.cpvVideoDurationType;

      // 从map里逐级往下找，直到找到string
      const key = [metric, optimizeGoal, cpvVideoDuration].reduce((previousValue, currentValue) => {
        if (typeof previousValue === 'string') {
          return previousValue;
        }
        return previousValue?.[currentValue] ?? '';
      }, matricMap);

      return {
        value: metric,
        key,
      };
    }),
  );

  return {
    keyMetricOptions,
    initKeyMetric,
  };
}

export function getSplitTestOptions() {
  return [
    {
      label: i18n.t('adgroup_target_card'),
      value: SplitTestType.TARGET,
      desc: i18n.t('module_campaign_split_test_choose_info'),
    },
    {
      label: i18n.t('ad_creative'),
      value: SplitTestType.CREATIVE,
      desc: i18n.t('module_campaign_split_test_info_creative'),
    },
    {
      label: i18n.t('adgroup_split_test_bidding'),
      value: SplitTestType.BIDDING,
      desc: i18n.t('module_campagin_split_test_info_bidding'),
    },
  ];
}
